import React, { useState, useEffect , useRef } from "react";
import { FileManager } from "@ray-solutions/react-file-manager";
import "@ray-solutions/react-file-manager/dist/react-file-manager.css";
import { useSelector , useDispatch } from "react-redux";
import { set_sharepoint_root_files } from "../../../slices/share_point/reducer";
import { share_point_directory_list } from "../../../helpers/fakebackend_helper";
import Loader from "../../../Components/Common/Loader";
import { Save_Share_Point_File_To_Knowledge } from "../../../slices/thunks";


const FileManagerWithSidebar = ({setselected_files}) => {
  const { share_point_root_file } = useSelector((state) => state.SharePoint);
  const { Bot_ID , Sharepoint_Details } = useSelector((state) => state.BotDetails.Bot_Details);

  const dispatch = useDispatch()
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
const containerRef = useRef(null);

  

  useEffect(() => {
    if (share_point_root_file && share_point_root_file.value) {
        const mappedFiles = share_point_root_file.value.map((ele) => {
        const { name, size, lastModifiedDateTime, parentReference, folder } = ele;
        const isDirectory = folder !== undefined;
        const path = (parentReference?.path ? `${parentReference.path}/${name}` : name).replaceAll("/drive/root:","");
        return {
          name,
          size,
          updatedAt: lastModifiedDateTime,
          path,
          meta_data: ele,
          isDirectory,
        };
      });

      setFiles(mappedFiles);
    }
  }, [share_point_root_file]);



  return (
    <div tabIndex={0} className="file-manager-container">
      
      <aside className="sidebar"></aside>
      <main className="content">
        <style>{`.fm-toolbar { display: none !important; }`}</style>
        {loading && (
        <div className="loader-overlay_cust">
          <Loader />
        </div>
      )}
        <FileManager
          files={files}
          layout="grid"
          height="100%"
          onCopy={(files)=>{
            return false
          }}
          onRefresh={() => console.log("Refresh")}
            onFileDownload={(file) => {
             // Prevent the default download behavior
          return false; // Returning false prevents the download
        }}
          onSelect={(selectedItems)=>{
    // Filter only files (isDirectory === false)
  
      setselected_files(selectedItems)
    
    const onlyFiles = selectedItems.filter(item => !item.isDirectory);

    // Optional: If needed, clean paths or apply transformations
    // const cleanedFiles = onlyFiles.map(file => file.path.replaceAll("/drive/root", ""));

    console.log("Selected Files Only:", onlyFiles);
    setselected_files(onlyFiles);
          }}
           permissions={[
            { path: "/**", read: true, create: false ,copy:false , move:false , delete:false , upload:false , rename:false },

          ]}
//           onFileOpen={async (file) => {
//             // Check if the clicked item is a folder
            
//             if (file.isDirectory) {
//               setLoading(true);
//                let response = await share_point_directory_list({ bot_id:Bot_ID , file_path:(file.meta_data.parentReference.path + `${file.name}:` ).replaceAll("/drive/root:","") })


//           const mappedFiles = response.value.map((ele) => {
//           const { name, size, lastModifiedDateTime, parentReference, folder } = ele;
//           const isDirectory = folder !== undefined;
//           const path = (parentReference?.path ? `${parentReference.path}/${name}` : name).replaceAll("/drive/root:", "");

//           return {
//             name,
//             size,
//             updatedAt: lastModifiedDateTime,
//             path,
//             meta_data: ele,
//             isDirectory,
//           };
//         });

// // Filter out files that already exist in the 'files' array based on the same 'name' and 'path'
//       const newFiles = mappedFiles.filter((newFile) => {
//         return !files.some((existingFile) => existingFile.path === newFile.path && existingFile.name === newFile.name);
//       });

//     // Append the new files that don't already exist
//     setFiles([...files, ...newFiles]);
   
               
//               //  dispatch(set_sharepoint_root_files(files))
//             } else {
//               setLoading(false);
//               console.log("File opened:", file);
//             }
//           }}
              onFileOpen={async (file) => {
                // console.log("File Data",file)
                if (file.isDirectory) {
                  setLoading(true); // show loader
                  try {
                    let response = await share_point_directory_list({
                      bot_id: Bot_ID,
                      file_path: (file.meta_data.parentReference.path + `/${file.name}:`).replaceAll("/drive/root:", ""),
                    });

                    const mappedFiles = response.value.map((ele) => {
                      const { name, size, lastModifiedDateTime, parentReference, folder } = ele;
                      const isDirectory = folder !== undefined;
                      const path = (parentReference?.path ? `${parentReference.path}/${name}` : name).replaceAll("/drive/root:", "");

                      return {
                        name,
                        size,
                        updatedAt: lastModifiedDateTime,
                        path,
                        meta_data: ele,
                        isDirectory,
                      };
                    });

                    const newFiles = mappedFiles.filter((newFile) => {
                      return !files.some(
                        (existingFile) => existingFile.path === newFile.path && existingFile.name === newFile.name
                      );
                    });

                    setFiles([...files, ...newFiles]);
                    setLoading(false);
                  } catch (err) {
                    console.error("Error loading folder:", err);
                  } finally {
                    setLoading(false); // always hide loader
                  }
                } else {
                  // console.log("File opened:", file);
                  setLoading(false);
                }
              }}

        />
      </main>
    </div>
  );
};

export default FileManagerWithSidebar;
